module.exports = "/_next/static/images/cross-d03e996f6b7b2c33b70f16dcbe253f81.svg";